import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M39.14 45.056a3 3 0 0 0 .86-2.103v-5.648a7.001 7.001 0 0 0 5.632-6.25C45.877 28.297 46 25.278 46 22c0-2.642-.08-4.958-.24-6.95a7 7 0 0 0-6.477-6.422C33.436 8.209 28.364 8 24.065 8c-4.31 0-9.425.21-15.344.63a7 7 0 0 0-6.482 6.424C2.08 17.044 2 19.36 2 22c0 3.274.122 6.288.367 9.043a7 7 0 0 0 6.47 6.362c5.177.373 10.288.56 15.333.56 1.148 0 2.296-.01 3.444-.03l7.283 7.158a3 3 0 0 0 4.243-.037Zm-.212-9.628a1 1 0 0 0-.928.997v6.528a1 1 0 0 1-1.7.713l-7.583-7.451a1 1 0 0 0-.72-.287c-1.276.024-2.551.036-3.827.036-4.997 0-10.06-.184-15.19-.554a5 5 0 0 1-4.62-4.544C4.12 28.172 4 25.216 4 22c0-2.59.078-4.853.233-6.786a5 5 0 0 1 4.63-4.588C14.738 10.209 19.806 10 24.065 10c4.247 0 9.273.207 15.075.623a5 5 0 0 1 4.627 4.587c.155 1.934.233 4.198.233 6.79 0 3.221-.12 6.18-.36 8.878-.218 2.44-2.172 4.364-4.712 4.55Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Message-Outlined_svg__a",
      width: 44,
      height: 38,
      x: 2,
      y: 8,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M39.14 45.056a3 3 0 0 0 .86-2.103v-5.648a7.001 7.001 0 0 0 5.632-6.25C45.877 28.297 46 25.278 46 22c0-2.642-.08-4.958-.24-6.95a7 7 0 0 0-6.477-6.422C33.436 8.209 28.364 8 24.065 8c-4.31 0-9.425.21-15.344.63a7 7 0 0 0-6.482 6.424C2.08 17.044 2 19.36 2 22c0 3.274.122 6.288.367 9.043a7 7 0 0 0 6.47 6.362c5.177.373 10.288.56 15.333.56 1.148 0 2.296-.01 3.444-.03l7.283 7.158a3 3 0 0 0 4.243-.037Zm-.212-9.628a1 1 0 0 0-.928.997v6.528a1 1 0 0 1-1.7.713l-7.583-7.451a1 1 0 0 0-.72-.287c-1.276.024-2.551.036-3.827.036-4.997 0-10.06-.184-15.19-.554a5 5 0 0 1-4.62-4.544C4.12 28.172 4 25.216 4 22c0-2.59.078-4.853.233-6.786a5 5 0 0 1 4.63-4.588C14.738 10.209 19.806 10 24.065 10c4.247 0 9.273.207 15.075.623a5 5 0 0 1 4.627 4.587c.155 1.934.233 4.198.233 6.79 0 3.221-.12 6.18-.36 8.878-.218 2.44-2.172 4.364-4.712 4.55Z",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Message-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgMessageOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageOutlined_default = SvgMessageOutlined;

export { MessageOutlined_default as default };
